export const PRIME_HKDF_INFO = "PrimeAssistant-ECDH-Transport-v1";
export const PRIME_TRANSPORT = "ecdh-aes-256-gcm";

export type EncryptedPayload = {
  encrypted: string;
  iv: string;
  tag: string;
};

export type EcdhEnvelope = {
  clientPublicKey: string;
  encrypted: EncryptedPayload;
};

export type E2eeInnerCall = {
  method: string;
  path: string;
  query?: string;
  body?: unknown;
};

export function isEncryptedPayload(value: unknown): value is EncryptedPayload {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as EncryptedPayload).encrypted === "string" &&
    typeof (value as EncryptedPayload).iv === "string" &&
    typeof (value as EncryptedPayload).tag === "string"
  );
}

export function isEcdhEnvelope(value: unknown): value is EcdhEnvelope {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as EcdhEnvelope).clientPublicKey === "string" &&
    isEncryptedPayload((value as EcdhEnvelope).encrypted)
  );
}
